export default __webpack_public_path__ + "static/media/car3.f069b618.png";